import React, { useContext, FC, ReactNode } from 'react';

import { makeStyles } from '@material-ui/core';
import { AuthContext, AuthStatus } from 'src/contexts/authContext';
import GuestHeader from 'src/views/workspace/components/layouts/GuestHeader';
import { useHistory } from 'react-router';
import { colors } from 'src/constants/theme/colors';
import { spacing } from 'src/constants/theme/spacing';
import { radius } from 'src/constants/theme/radius';
import NavTop from './NavTop';
import NavRight from './NavRight';
import NavLeft from './NavLeft';

interface EditorLayoutProps {
  children?: ReactNode;
}

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    minWidth: 1400,
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: colors.background.canvas,
    overflow: 'hidden'
  },
  container: {
    flex: 1,
    minWidth: 1400,
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    gap: spacing.sm,
    padding: spacing.sm,
    overflow: 'hidden'
  },
  templateWrapper: {
    flex: 1,
    minWidth: '42rem',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colors.background.secondary,
    borderRadius: radius.xl,
    overflowX: 'auto',
    overflowY: 'auto'
  },

  sideWrapper: {
    width: '340px',
    minWidth: '340px',
    display: 'flex'
  },

  guestHeaderWrapper: {
    background: colors.background.primary,
    width: '100%',
    minWidth: 1400
  },
  guestHeader: {
    background: colors.background.primary,
    color: colors.text.primary,
    border: colors.border.default,
    buttonColor: colors.text.primary,
    buttonBackground: colors.background.tertiary
  }
}));

const EditorLayout: FC<EditorLayoutProps> = ({ children }) => {
  const classes = useStyles();
  const history = useHistory();

  const { authStatus } = useContext(AuthContext);
  const isGuest = authStatus !== AuthStatus.SignedIn;
  const onClickLogoGuest = () => {
    history.push('/workspace/templates');
  };

  return (
    <>
      {isGuest && (
        <div className={classes.guestHeaderWrapper}>
          <GuestHeader
            onClickLogoGuest={onClickLogoGuest}
            isBlack
            style={{
              background: 'black',
              color: 'white',
              border: 'white',
              buttonColor: 'white',
              buttonBackground: '#333333'
            }}
          />
        </div>
      )}
      <div className={classes.root}>
        <NavTop />
        <div className={classes.container}>
          <div className={classes.sideWrapper}>
            <NavLeft />
          </div>
          <div className={classes.templateWrapper}>{children}</div>
          <div className={classes.sideWrapper}>
            <NavRight />
          </div>
        </div>
      </div>
    </>
  );
};

export default EditorLayout;
